import { FormFields } from "../../../../models/newSupportCall";
import SupportCallOccurrenceFields from "../SupportCallOccurrenceFields";

export interface IAdministrativeFormData {
    formData: FormFields;
    errors: Partial<Record<keyof FormFields, string>>;
    subject: string;
    updateField: <K extends keyof FormFields>(field: K, value: FormFields[K]) => void;
    name: string;
    fetchVehicle: (chassis: string) => Promise<void>
}

const AdministrativeForm = ({ formData, errors, updateField, subject, name, fetchVehicle }: IAdministrativeFormData) => {
    return (
        <>
            <SupportCallOccurrenceFields
                formData={formData}
                errors={errors}
                updateField={updateField}
                name={name}
                fetchVehicle={fetchVehicle}
                subject={subject}
            />
            <div className='margin-top-20'>
                <p className='text-size-16 text-bold'>2. Dados adicionais</p>
                <div className='padding-15 margin-top-20 rounded border'>
                    <p className='text-size-14 text-color-darker'>Detalhe da solicitação *</p>
                    <textarea
                        className="form-control margin-top-10"
                        rows={3}
                        placeholder="Obrigatório"
                        value={formData.customerComment}
                        onChange={event => updateField('customerComment', event.target.value)}
                    />
                    {errors.customerComment ? (
                        <span className='text-size-12 text-color-danger'>{errors.customerComment}</span>
                    ) : null}
                </div>
            </div>
        </>
    )
}

export default AdministrativeForm;
